import { get } from '@/libs/api.request'

export default {
  state: {
    configs: {},
    loading: false,
    labors: [],
    /**
     * @deprecated
     */
    productTypes: [],
    /**
     * @deprecated
     */
    productPhases: [],
    /**
     * @deprecated
     */
    partTypes: [],
    taxonomyTerms: {}
  },
  getters: {
    productPhases: (state) => {
      return state.productPhases
    }
  },
  mutations: {
    setConfigs(state, configs) {
      state.configs = configs
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    setLabors(state, labors) {
      state.labors = labors
    },
    /**
     * @deprecated
     */
    setProductTypes(state, productTypes) {
      state.productTypes = productTypes
    },
    /**
     * @deprecated
     */
    setProductPhases(state, productPhases) {
      state.productPhases = productPhases
    },
    /**
     * @deprecated
     */
    setPartTypes(state, partTypes) {
      state.partTypes = partTypes
    },
    setTaxonomyTerms(state, type, data) {
      state.taxonomyTerms[type] = data
    }
  },
  actions: {
    getConfigs ({ commit }, data) {
      return get('core/config', data).then(res => {
        commit('setConfigs', res.data)
      })
    },
    getLabors ({ commit }, data) {
      get('core/costs/labor-roles', data).then(res => {
        commit('setLabors', res.data)
      })
    },
    /**
     * @deprecated
     */
    getTerms ({ commit }, data) {
      get('core/terms', data).then(res => {
        switch (data.type) {
          case 'product_type':
            commit('setProductTypes', res.data)
            break
          case 'product_phase':
            commit('setProductPhases', res.data)
            break
          case 'part_type':
            commit('setPartTypes', res.data)
            break
        }
      })
    },
    /**
     * Avaliable types:
     *  cost_references,
     *  cost_tags,
     *  cost_fees,
     *  deal_types,
     *  deal_stages,
     *  deal_tech_info_received
     */
    getTaxonomyTerms ({ commit, state }, type) {
      return new Promise((resolve, reject) => {
        if (_.get(state.taxonomyTerms, type)) {
          resolve(_.get(state.taxonomyTerms, type))
        } else {
          get(`taxonomy/terms/${type}`).then(res => {
            commit('setTaxonomyTerms', type, res.data)
            resolve(res.data)
          }).catch(error => {
            reject(error)
          })
        }
      })
    }
  }
}
